// extracted by mini-css-extract-plugin
export default {"wrapper":"Drink_wrapper__xRyMl","container":"Drink_container__bh4UB","list":"Drink_list__9Zag-","products":"Drink_products__sWqdK"};